import { getTimeOutDate } from '@helpers/FormalOffers/getTimeOutDate';
import { Tooltip } from '@iwoca/orion';
import { FormattedDate, FormattedMessage } from 'react-intl';

import styles from './ApprovalHeader.module.css';
import ApprovalSubHeader from './approvalSubHeader/ApprovalSubHeader';
import InternationalisedName from '../../../multiLoanDashboard/dashboardComponents/InternationalisedName';
import { MoneyNoDecimals } from '../../../ui/moneyNoDecimals';
import { FormalOffer } from '../../MyOffers.types';

const ApprovalHeader = ({
    approvalStatusTimeOut,
    maxCashAmount
}: {
    approvalStatusTimeOut: ReturnType<typeof getTimeOutDate>;
    maxCashAmount: FormalOffer['max_amount'];
}) => (
    <div className={styles.header} data-testid="approval-header">
        <div
            className={styles.headerCustomerIntroduction}
            data-testid="headerLB"
        >
            <FormattedMessage
                id="_.loan_builder.header"
                defaultMessage="Hi {name}, you’re approved for {offeredAmount} - valid until {timeoutDate}{tooltip}"
                values={{
                    name: (
                        <span>
                            <InternationalisedName />
                        </span>
                    ),
                    offeredAmount: (
                        <span className={styles.headerBlue}>
                            <MoneyNoDecimals value={maxCashAmount} />
                        </span>
                    ),
                    timeoutDate: (
                        <span className={styles.headerBlue}>
                            <FormattedDate
                                value={new Date(approvalStatusTimeOut)}
                                day="2-digit"
                                month="long"
                                year="numeric"
                            />
                        </span>
                    ),
                    tooltip: (
                        <span className={styles.headerTooltip}>
                            <Tooltip
                                // @ts-expect-error
                                content={
                                    <FormattedMessage
                                        id="_.loan_builder.header_tooltip"
                                        defaultMessage="If you miss this window, you'll just need to re-apply in your iwoca account."
                                    />
                                }
                            />
                        </span>
                    )
                }}
            />
        </div>
        <ApprovalSubHeader />
    </div>
);

// eslint-disable-next-line import/no-default-export
export default ApprovalHeader;
